export const loginMutation = "loginMutation";
export const userInfoMutation = "userInfoMutation";
// 导航列表
export const firstMenuMutation = "firstMenuMutation";
export const firstMenuMapMutation = "firstMenuMapMutation";

export const secondMenuMutation = "secondMenuMutation";
export const secondMenuMapMutation = "secondMenuMapMutation";

export const thirdMenuMutation = "thirdMenuMutation";
export const thirdMenuMapMutation = "thirdMenuMapMutation";